import type { TrackingScopeValue } from "@/contexts/trackingScopeContext";
import {
  clientAnalyticsEventSchema,
  type ClientAnalyticsEvent,
} from "@/lib/site-tracking/trackClientEvent";

export type ScopedClientAnalyticsEvent = ClientAnalyticsEvent extends infer Event
  ? Event extends { name: infer Name; properties: infer Properties }
    ? {
        name: Name;
        properties: Omit<Properties, "entity_type" | "surface"> &
          Partial<Pick<Properties, Extract<keyof Properties, "entity_type" | "surface">>>;
      }
    : never
  : never;

function trackingContextProperties(scope: TrackingScopeValue) {
  return scope.entityType
    ? { entity_type: scope.entityType, surface: scope.surface }
    : { surface: scope.surface };
}

/** Merges accumulated scope with event-local properties. */
export function buildScopedClientAnalyticsEvent(
  scope: TrackingScopeValue,
  event: ScopedClientAnalyticsEvent,
): ClientAnalyticsEvent | null {
  const result = clientAnalyticsEventSchema.safeParse({
    ...event,
    properties: {
      ...trackingContextProperties(scope),
      ...event.properties,
    },
  });

  return result.success ? result.data : null;
}
